import './DetailSection.scss';
import classNames from 'classnames';
import { Row } from 'antd';
import { When } from 'react-if';
import React, { PropsWithChildren } from 'react';

export interface DetailSectionProps {
	className?: string;
	headerAction?: React.ReactNode;
	spacing?: 'none' | 'small' | 'medium' | 'large';
	title?: string;
}

export const DetailSection: React.FC<PropsWithChildren<DetailSectionProps>> = ({
	children,
	className,
	headerAction,
	spacing = 'medium',
	title
}) =>
	<div className={ classNames('detail-section', className) }>
		<When condition={ Boolean(title) || Boolean(headerAction) }>
			<div className='h2 detail-section-header'>
				<Row
					className='h2'
					justify='space-between'>
					{ title }
					{ headerAction }
				</Row>
			</div>
		</When>
		<div
			className={ classNames('detail-section-body', {
				'detail-section-body-large-spacing': spacing === 'large',
				'detail-section-body-no-spacing': spacing === 'none',
				'detail-section-body-small-spacing': spacing === 'small'
			}) }>
			{ children }
		</div>
	</div>;

